var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_42",
    "data-name": "Rettangolo 42",
    width: 55,
    height: 48,
    fill: "#f2f5ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Video",
    "data-name": "Iconly/Bold/Video",
    transform: "translate(17.5 17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-2",
    "data-name": "Video",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M9.905,0a3.91,3.91,0,0,1,4.113,4.061h0v6.878A3.91,3.91,0,0,1,9.905,15H4.113A3.91,3.91,0,0,1,0,10.939H0V4.061A3.91,3.91,0,0,1,4.113,0H9.905Zm8.053,2.379a1.383,1.383,0,0,1,1.373.064A1.43,1.43,0,0,1,20,3.662h0v7.676a1.429,1.429,0,0,1-.669,1.219,1.4,1.4,0,0,1-.743.216,1.384,1.384,0,0,1-.631-.153h0l-1.481-.747a1.623,1.623,0,0,1-.888-1.457h0V4.583a1.618,1.618,0,0,1,.888-1.456h0Z",
    transform: "translate(0 0)",
    fill: "#8b9cce"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.6022eb13f055ed0bfe5d0b7a0192a11f.svg";
export { ForwardRef as ReactComponent };